import { render, staticRenderFns } from "./GTUserMappingDetail.vue?vue&type=template&id=01735f92&scoped=true"
import script from "./GTUserMappingDetail.vue?vue&type=script&lang=js"
export * from "./GTUserMappingDetail.vue?vue&type=script&lang=js"
import style0 from "./GTUserMappingDetail.vue?vue&type=style&index=0&id=01735f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01735f92",
  null
  
)

export default component.exports